var lockController,timeoutBloqueig;
var markerLocationEditor=null;
jQuery(document).ready(function() {
	var consent = Cookies.get('cookieconsentICGC_status');
	if (consent==undefined || consent!="allow") {
			window.location.href = paramUrl.cookiesPage;	
	}
	else {
		if(typeof url('?uid') == "string"){
			//gestioCookie();
			Cookies.remove('uid');
			Cookies.set('uid', url('?uid'));
		}
	
		defineTipusUser();
	
		if (tipus_user == t_user_loginat){
			var data = {
					uid: Cookies.get('uid'),
					businessId: url('?businessid'),
					mapacolaboratiu: url('?mapacolaboratiu')
				};
				getUserSimple(data).then(function(results){
					Cookies.set('userId', results.results.id);
					_UsrID=results.results.id;
					loadApp();
					map.zoomControl.setPosition('bottomright');
					$('[data-toggle="tooltip"]').tooltip({ container: 'body' });
				});
		}else{
			loadApp();
			if(map){
			map.zoomControl.setPosition('bottomright');
			}
			$('[data-toggle="tooltip"]').tooltip({ container: 'body' });
		}
	}

}); // Final document ready


function loadApp(){

	if(typeof url('?businessid') == "string"){
		map = new L.IM_Map('map', {
			zoomControl: true,
			zoomAnimation:false,
			dragging: true,
			touchZoom: true,
			scrollWheelZoom: true,
			doubleClickZoom: true,
			boxzoom: true,
			typeMap : 'topoMapGeo',
			minZoom: 2,
			maxZoom : 19,
			maxBounds: L.latLngBounds(L.latLng(-90, -180), L.latLng(90, 180)),
			attributionControl: false,
			timeDimension: true,
		    timeDimensionControl: true,
		    timeDimensionControlOptions:{
		    	speedSlider:false
		    }
			//drawControl: true
		}).setView([ 41.431, 1.8580 ], 8);

		L.control.coordinates({
			position : 'bottomright',
			'emptystring':' ',
			'numDigits': 2,
			'numDigits2': 6,
			'prefix': 'ETRS89 UTM 31N',
			'prefix2': 'WGS84',
			'separator': ' ',
			'showETRS89':true
		}).addTo(map);

		
		L.control.scale({position : 'bottomright', 'metric':true,'imperial':false}).addTo(map);

		//Nivell de zoom del mapa
		var zoomDisplayControl = new L.Control.ZoomDisplay();
		zoomDisplayControl.addTo(map);
		
		InstamapsUtils.Cookie.gestioCookie("loadApp", paramUrl, Cookies, url);

		var data = {
			businessId: url('?businessid'),
			uid: Cookies.get('uid'),
			mapacolaboratiu: url('?mapacolaboratiu')
		};

		getUserSimple(data).then(function(results){
			Cookies.set('userId', results.results.id);
			_UsrID=results.results.id;
		});

		getMapByBusinessId(data).then(function(results){
			if (results.status == "ERROR"){
				InstamapsUtils.Cookie.gestioCookie("getMapByBusinessId", paramUrl, Cookies, url);
			}
			else if (results.status == "KO"){
				var uidBloq = results.results;
				var txt = window.lang.translate("Mapa bloquejat per l'usuari:")+uidBloq+".\n";
				txt += window.lang.translate("Quan aquest usuari surti de la sessió d'edició podràs treballar amb aquest mapa.");
				alert(txt);
				InstamapsUtils.Cookie.gestioCookie("getMapByBusinessId2", paramUrl, Cookies, url);
			}
			else{
				if (Cookies.get('collaboratebid')) Cookies.remove('collaboratebid');
				if (Cookies.get('collaborateuid')) Cookies.remove('collaborateuid');
				try{
					mapConfig = results.results;
					if (typeof mapConfig.bloquejat == "string" && mapConfig.bloquejat.indexOf("bloquejat")>-1 && mapConfig.bloquejat.indexOf("null")==-1) {
						var bloquejatJson=$.parseJSON(mapConfig.bloquejat);
						jQuery.map( bloquejatJson, function( val, i ) {
								if (val.bloquejat==="S") {
									InstamapsUtils.Cookie.gestioCookie("mapaBloquejat", paramUrl, Cookies, url);
									lockController = InstamapsUtils.Mapa.controlarBloqueigMapa(jQuery, url, Cookies, lockController, runningActions, desbloquejarMapa);
								}
						});
					}
					InstamapsUtils.Cookie.gestioCookie("diferentUser", paramUrl, Cookies, url);
					var nomAp = mapConfig.nomAplicacio;
					$('meta[property="og:title"]').attr('content', "InstaMaps: "+nomAp.replaceAll("'","\'"));

					if(typeof (mapConfig.options)=="string"){
						mapConfig.options = $.parseJSON( mapConfig.options );
					}

					if (mapConfig.options){
						var desc = mapConfig.options.description;
						if (desc!=undefined) desc=desc.replaceAll("'","\'");
						$('meta[name="description"]').attr('content', desc);

						$('meta[property="og:description"]').attr('content', desc);

						var urlThumbnail = GEOCAT02 + paramUrl.urlgetMapImage+ "&request=getGaleria&update=false&businessid=" + url('?businessid');
						$('meta[property="og:image"]').attr('content', urlThumbnail);
					}

					mapLegend = (mapConfig.legend? $.parseJSON( mapConfig.legend):[]);

					downloadableData = (mapConfig.options && mapConfig.options.downloadable?
											mapConfig.options.downloadable:[]);

					mapConfig.newMap = false;

					//Afegim barres d'eines i control de capes
					addControlsInici().then(function(){
						loadMapConfig(mapConfig).then(function(){
						
							changeLogoByTipusEntitat(Cookies.get('tipusEntitat'));

							$('#nomAplicacio').html(mapConfig.nomAplicacio);
							//llegim configuracio de funcionalitats del mapa, si no te, per defecte
	
							var configuracio = "";
							loadConfiguracio(mapConfig.configuracio).then(function(results){
								//iniciem els controls basics
								initControls();
								
								//careguem funcionalitats:
								loadControls(results);
								//Actualitzar idiomes
								updateLangText();
	
								//Actulitza idioma dels tooltips
								$("body").on("change-lang", function(event, lang){
									addDrawTooltips();//Actualitzem tootltips funcionalitat draw
									window.lang.change(lang);
									updateLangTooltips();
									updateLangText();
								});
								canviaIdioma(web_determinaIdioma());
								document.title = "InstaMaps: "+mapConfig.nomAplicacio;
								

								//Euroregio
								changeFonsListByTipusEntitat(Cookies.get('tipusEntitat'));
								changeFonsByTipusEntitat(Cookies.get('tipusEntitat'));
								changeVistaInicialByTipusEntitat(Cookies.get('tipusEntitat'));
								
							});
	
							//carreguem WMS en cas que s'hagi passat parametres
							if(typeof url('?urlwms') == "string"){
								ActiuWMS.url = url('?urlwms');
								var layername = url('?layername');
	
								ActiuWMS.servidor = layername;
								ActiuWMS.layers = layername;
								ActiuWMS.epsg = undefined;
	
								addExternalWMS(true);
							}
	
						});
					});

					map.fire('loadconfig', mapConfig);
					$.publish('loadConfig', mapConfig);
						
				}catch(err){
					console.log(err);
					InstamapsUtils.Cookie.gestioCookie("loadMapConfig", paramUrl, Cookies, url);
				}
			}
		},function(results){
			InstamapsUtils.Cookie.gestioCookie("getMapByBusinessIdError", paramUrl, Cookies, url);
		});
		addLeaveModal();

	}else{
		if (!Cookies.get('uid')){
			createRandomUser().then(function(results){
				if (results.status==='OK'){
					var user_login = results.results.uid;
					var pass_login = "user1234";
					var dataUrl = {user:user_login, password:pass_login};
					doLogin(dataUrl).then(function(results){
						if(results.status==='OK'){
							Cookies.set('uid', user_login);
							createNewMap();
						}
					});
				}
			});
		}else{
			mapConfig.newMap = true;
			createNewMap();
		}
	}

	/********Events*************/

	$.subscribe('reloadMapConfig',function(e, namespace){
		if (namespace){
			$.publish(namespace+'loadMapConfig', mapConfig);
		}else{
			$.publish('loadMapConfig', mapConfig);
		}
	});

	$.subscribe('getMap',function(e, namespace){
		if (namespace){
			$.publish(namespace+'setMap', map);
		}else{
			$.publish('setMap', map);
		}
	});

	$.subscribe('updateMapConfig',function(e, data){
		mapConfig = data;
	});
}

function initControls(){

	checkUserLogin();

	addClicksInici();
	InstamapsUtils.Mapa.redimensioMapa(jQuery, url, '#map');
	addHtmlModalOldBrowser();

	addHtmlModalExpire();
	addHtmlModalMessages();

	addHtmlModalAddLayer();
	//carrega font de dades
	generaLListaDadesObertes();
	generaLlistaServeisWMS();

	//Afegir modul3D
	addModul3D(mapConfig);
	
	//afegir cerca EPSG
	
	addSearchOptionsEPSG();
}

function addClicksInici() {

	jQuery('.bt_llista').on('click', function(event) {
		InstamapsUtils.Dom.aturaClick(event);
		InstamapsUtils.Mapa.activaPanelCapes(true, jQuery);
		if(InstamapsUtils.Validator.isModeMapa($(location).attr('href'))){
			updateSortablesElements();
		}
	});
	
	//Edicio de feature existent
	map.on('click',function(e){
		if ( !e.ctrlKey && e.keyCode == 27) {
			InstamapsUtils.Mapa.openPopupOnClick(e);
		}
	});

	document.body.onkeydown= function(e){
		if (e.keyCode == 27) InstamapsUtils.Mapa.saveEditedLayer(e); // esc   
	};
	
	
	jQuery('#ch_idioma li').click(function() {
		jQuery('#ch_idioma li').removeClass('active');
		jQuery(this).addClass('active');
		canviaIdioma(jQuery(this).attr('id'));
    });
	
	//para activar el idioma en el desplegable cuando se carga la página 
	jQuery('#ch_idioma li').removeClass('active');
	jQuery('#ch_idioma li').each(function(index, item){
		if(jQuery(item).attr('id') === web_determinaIdioma()){
			jQuery(item).addClass('active');
		}
	});


	jQuery('.inciarSessio').click(function(){
		if (InstamapsUtils.Validator.isRandomUser(Cookies.get('uid'))){
			$(window).off('beforeunload');
			$(window).off('unload');
			window.location = paramUrl.loginPage+"?from=mapa";
		}
	});
}

function addControlsInici(){
	var dfd = jQuery.Deferred();

	$.get("/static/geocatweb/templates/popup.html",function(data){
		$('.wrapper').html(data);
		$('#closeSidebar').on('click',function(){
			$('#sidebar').attr("class","unactive");
			$('.leaflet-control-scale.leaflet-control').removeClass("popup-active");
		});
	});
	$.get("static/geocatweb/templates/header.html",function(data){
		$("#header").html(data);
		/*$("#contacte").on('click',function(e){
			var htmlContact = "mailto:instamaps@icgc.cat";
			if (url('?businessid')){
				htmlContact += "?subject=Mapa amb businessId "+url('?businessid')+"&body=Mapa amb businessId "+url('?businessid');
			}
			e.originalEvent.currentTarget.href=htmlContact;
		});*/
	});

	loadSideBar(mapConfig).then(function(){
		dfd.resolve();
	});
	
	$.get("static/geocatweb/templates/footer.html",function(data){
		$("#footer").html(data);
		initCookies();
	});

	$.get("static/geocatweb/templates/modalAttribution.html",function(data){
		$('#mapa_modals').append(data);
		$('#dialog_info_attribution').find('.modal-title').html(mapConfig.nomAplicacio);
		$('#dialog_info_attribution').find('.modal-body').find('.attribution').html(InstamapsUtils.Mapa.getAtributionControlHtml(map));
		if(map.attributionControl){
			map.attributionControl.container = $('#dialog_info_attribution').find('.modal-body').find('.attribution');
		}else{
			map.attributionControl = {container: $('#dialog_info_attribution').find('.modal-body').find('.attribution')};
		}
	});
	
	controlCapes = L.control.orderlayers(null, null, {
		collapsed: false,
		editMode: true,
		id: 'div_capes',
		autoUpdate: false,
		mapConfig: mapConfig
	});

	console.debug(controlCapes);

	controlCapes.addTo(map);

	
	ctr_legend = L.control.legend({
		title: window.lang.translate('Llegenda'),
		tipusllegenda: "dinamica",  //"dinamica"
		llegendaOpt: true, //true
		origenllegenda:'mapa'
	}).addTo(map);

	console.debug("control llegenda:"+ctr_legend);
	
	map.on('addItemFinish',function(){
		$(".layers-list").mCustomScrollbar("destroy");
		$(".layers-list").mCustomScrollbar({
			   advanced:{
			     autoScrollOnFocus: false,
			     updateOnContentResize: true
			   }
		});
	});

	var ctr_llistaCapes = L.control({
		position : 'topright'
	});
	ctr_llistaCapes.onAdd = function(map) {

		this._div = L.DomUtil.create('div', 'div_barrabotons btn-group-vertical');

		var btllista = jQuery("<div data-toggle=\"tooltip\" class=\"leaflet-bar btn btn-default btn-sm bt_llista\" title=\"Llista de capes\" data-lang-title=\"Llista de capes\"><span class='glyphicon glyphicon-th-list grisfort'></span></div>");
		this._div.appendChild(btllista[0]);

		var bt3D_2D = jQuery("<div data-toggle=\"tooltip\" class=\"leaflet-bar btn btn-default btn-sm bt_3D_2D\" title=\"Canviar vista\" data-lang-title=\"Canviar vista\"><span class='text3D'>3D</span></div>");
		this._div.appendChild(bt3D_2D[0]);

		return this._div;
	};
	ctr_llistaCapes.addTo(map);

	jQuery('.div_barrabotons .leaflet-bar').tooltip({
		placement : 'left',
		container : 'body'
	});

	//TODO mirarse para unificar y utilizar sólo un popupmanager en el mapa MEGAREFACTORING
	PopupManager();

	return dfd.promise();
}

function initCookies(){
	var host = HOST_APP.replace("http://","");
	host = host.replace("https://","");
	host = host.replace("/","");
	new icgc.CookiesICGC(host, ["UA-46332195-6", "UA-46332195-12"], {
		container: "#cookies",
		configBtnSelector: "#cookies-footer", 
		configBtn: "<div class='cc-config '>Cookies</div>"
	}); 
	/*
	var host = HOST_APP.replace("http://","");
	host = host.replace("https://","");
	host = host.replace("/","");
	
	new icgc.CookiesICGC(host, ["UA-46332195-6", "UA-46332195-3"], {
		configBtnSelector: "#cookies-footer", 
		configBtn: "<div class='cc-config '>Cookies</div>"
	});
	*/
}

function addLayerControl(container, control, map){
	try{
		container.html(control.onAdd(map));		
		var div = control.getContainer();
		$(div).show();
	}catch(e){

	}
}

function addLegendControl(container, control, map){
	try{
		container.html(control.onAdd(map));
		control.show();
	}catch(e){

	}
	/*control.hideBtn();
	control.show();*/
}

function addExportTools(divExport){
	var _scope = 'visor';
	InstamapsUtils.Validator.isModeMapa($(location).attr('href')) ? _scope = 'mapa' : _scope = 'visor';
	var btcamera = jQuery(
	"<div data-toggle=\"tooltip\" title=\"Capturar la vista del mapa\" data-lang-title=\"Capturar la vista del mapa\"><div class=\"bt_captura bt_exportar\"><span class='glyphicon glyphicon-camera grisfort'></span></div> <span class='span_exportar' lang='ca'>Capturar la vista del mapa</span><br/> </div>" )
	.on('click',
	function(event) {
		InstamapsUtils.Dom.aturaClick(event);
		capturaPantalla(CAPTURA_MAPA, mapConfig);
	});

	divExport.append(btcamera[0]);

	var btprint = jQuery(
	"<div data-toggle=\"tooltip\" title=\"Imprimir la vista del mapa\" data-lang-title=\"Imprimir la vista del mapa\"><div class=\"bt_print bt_exportar\"><span class='glyphicon glyphicon-print grisfort'></span></div><span class='span_exportar' lang='ca'>Imprimir la vista del mapa</span><br/></div>")
	.on('click',
	function(event) {
		InstamapsUtils.Dom.aturaClick(event);
		capturaPantalla(CAPTURA_INFORME, mapConfig);
	});
	divExport.append(btprint[0]);

	/*
	var btprintscale = jQuery(
	"<div data-toggle=\"tooltip\" title=\"Imprimir mapa a escala\" data-lang-title=\"Imprimir mapa a escala\"><div class=\"bt_scale bt_exportar\"><span class='fa fa-object-group grisfort'></span></div><span class='span_exportar' lang='ca'>Imprimir mapa a escala</span><br/></div>")
	.on('click',
	function(event) {
		InstamapsUtils.Dom.aturaClick(event);
		capturaWMSMAP(mapConfig.id, mapConfig.businessId, mapConfig.nomAplicacio, mapConfig.entitatId);
	});
	divExport.append(btprintscale[0]);
*/
	var btgeopdf = jQuery(
	"<div data-toggle=\"tooltip\" title=\"Descarrega mapa en format GeoPDF\" data-lang-title=\"Descarrega mapa en format GeoPDF\"> <div class=\"bt_geopdf bt_exportar\"><span class='fa fa-file-pdf-o geopdf'></span></div><span class='span_exportar' lang='ca'>Format GeoPDF</span><br/></div>")
	.on('click',
	function(event) {
		InstamapsUtils.Dom.aturaClick(event);
		capturaPantalla(CAPTURA_GEOPDF, mapConfig);
	});
	divExport.append(btgeopdf[0]);

	var btgeotiff = jQuery(
	"<div data-toggle=\"tooltip\" title=\"Descarrega mapa en format GeoTiff\" data-lang-title=\"Descarrega mapa en format GeoTiff\"><div class=\"bt_geotiff bt_exportar\" ><span class='fa fa-file-image-o grisfort'></span></div><span class='span_exportar' lang='ca'>Format GeoTiff</span><br/></div>")
	.on('click',
	function(event) {
		InstamapsUtils.Dom.aturaClick(event);
		capturaPantalla(CAPTURA_MAPA_GEOTIFF, mapConfig);
	});
	divExport.append(btgeotiff[0]);

	var btgeopkg = jQuery(
	"<div data-toggle=\"tooltip\" title=\"Descarrega vectors en format GeoPackage\" data-lang-title=\"Descarrega vectors en format GeoPackage\"><div class=\"bt_geopkg bt_exportar\"><span class='fa fa-database grisfort'></span></div><span class='span_exportar' lang='ca'>Format GeoPackage</span><br/></div>")
	.on('click',
	function(event) {
		InstamapsUtils.Dom.aturaClick(event);
		capturaPantalla(CAPTURA_MAPA_GEOPACKAGE, mapConfig);
	});
	divExport.append(btgeopkg[0]);
}

function gestionarPanel(id, idPare){
	var object = $('#'+id);
	var objectPare = $('#'+idPare);
	if (object.attr("style")  && object.attr("style").indexOf("none")>-1){
		object.attr("style","display:block;");
		objectPare.parent().parent().attr("style","background-color:#e5e5e5;height:56px;");
	}
	else {
		object.attr("style","display:none;");
		objectPare.parent().parent().attr("style","background-color:white");
	}
}

function cierraPanels(idPanel, idOpen){
	var panels = $('#'+idPanel).find('.item_panel').each(function(index){
		if (this.id !== idOpen){
			$(this).attr("style","display:none;");
			$(this).prev().attr("style","background-color:white");
		}
	});
}

function updateLangTooltips(){
	jQuery('body').on('show.bs.tooltip','[data-toggle="tooltip"]',function(){
		jQuery(this).attr('data-original-title', window.lang.translate(jQuery(this).data('lang-title')));
	});

	jQuery("#dv_bt_vistaInicial").on('click',function(e){
		if (mapConfig.options && mapConfig.options.bbox){
			var bbox = mapConfig.options.bbox.split(",");
			var southWest = L.latLng(bbox[1], bbox[0]);
		    var northEast = L.latLng(bbox[3], bbox[2]);
		    var bounds = L.latLngBounds(southWest, northEast);
			map.fitBounds( bounds );
		}
		else if (mapConfig.options && mapConfig.options.center){
			var opcenter = mapConfig.options.center.split(",");
			map.setView(L.latLng(opcenter[0], opcenter[1]), mapConfig.options.zoom);
		}else{


			map.setView([ 41.4324, 1.1453 ], 8);
		}
		InstamapsUtils.Dom.aturaClick(e);
	});
	
	//Footer buttons
	jQuery("#dv_bt_info").on('click',function(e){
		jQuery('#dialog_info_attribution').modal('show');
	});

	jQuery("#locateOffIcon").on('click',function(e){
		deleteLocateMarkeEditor();
	});

	jQuery("#locateIcon").on('click',function(e){
		locateUserEditor();
	});
}


function locateUserEditor() {
	map.locate({watch: true, setView: false,  timeout: 10000}) /* This will return map so you can do chaining */
    .on('locationfound', function(e){
        if (markerLocationEditor) {
            map.removeLayer(markerLocationEditor);
        }
        markerLocationEditor = L.circleMarker([e.latitude, e.longitude]);       
        map.addLayer(markerLocationEditor);
        map.setZoom(16);
    })
    .on('locationerror', function(e){
        console.log(e);
        alert("Location access denied.");
    });

}


function deleteLocateMarkeEditor(){
  if (markerLocationEditor!==null)  {      
      map.removeLayer(markerLocationEditor);
      markerLocationEditor=null; 
  }

}

function updateLangText(){

	//Add tooltip caixa cerca
	jQuery(".leaflet-control-search .search-button, .glyphicon-search").attr('title',window.lang.translate('Cercar llocs o coordenades ...'));
	jQuery(".leaflet-control-search .search-input").attr('placeholder',window.lang.translate('Cercar llocs o coordenades ...'));

	$('#funcio_draw #funcio_draw_titol_1').text(window.lang.translate("Situar un punt"));
	$('#funcio_draw #funcio_draw_titol_2').text(window.lang.translate("Dibuixar una línia o un polígon"));
	$('#funcio_tematics>h5').text(window.lang.translate("Triar l'estil de la capa"));
	$('#funcio_fonsMapes>h5').text(window.lang.translate("Escollir el mapa de fons"));
	var txtBoto="";
	if (mapConfig.bloquejat!=undefined  && mapConfig.bloquejat!='' && mapConfig.bloquejat!='[{}]' && mapConfig.bloquejat!='N'
		&& mapConfig.bloquejat!='[{"bloquejat":"N"}]' && mapConfig.bloquejat!='[{"uid":null,"bloquejat":null}]'){
		txtBoto="Desar / Desbloquejar";
	}
	else{
		txtBoto="Desar / Publicar el mapa";
	}
	$('.bt_publicar>span').text(window.lang.translate(txtBoto));
	$('#socialShare>h5').text(window.lang.translate("Compartir"));

	//Traducció dels textos del modal de publicar
	$('#titlePublicar').text(window.lang.translate('Publicar el mapa'));
	$('#id_info_tab').text(window.lang.translate('Informació'));
	$('#id_privacitat_tab').text(window.lang.translate('Privacitat'));
	$('#id_llegenda_tab').text(window.lang.translate('Llegenda'));
	$('#id_reuse_tab').text(window.lang.translate('Reutilització'));


	$('#nomAplicacioPub').attr("placeholder", window.lang.translate("Nom"));
    $('#optDescripcio').attr("placeholder", window.lang.translate("Descripció"));
    $('#optTags').attr("placeholder", window.lang.translate("Etiquetes"));
    $('#optAlies').attr("placeholder", window.lang.translate("Àlies de l'usuari (nom públic de l'autor)"));
	$('#publish-warn-text').text(window.lang.translate('El mapa es publicarà amb la vista actual: àrea geogràfica, nivell de zoom i capes visibles'));


    $('#llegendaTitle').text(window.lang.translate('Llegenda'));
    $('#textLegend').text(window.lang.translate('Escull si vols o no generar la llegenda associada al mapa'));

    $('#checkObert').text(window.lang.translate('Obert'));
    $('#checkRestringit').text(window.lang.translate('Restringit'));
    $('#txtPublic').text(window.lang.translate("Tothom amb l'enllaç pot accedir al mapa"));
    $('#txtPrivat').text(window.lang.translate("L'accés al mapa es protegit amb clau"));
    $('#checkPublic').text(window.lang.translate('Públic'));
    $('#checkPrivat').text(window.lang.translate('Privat'));
    $('#txtVisible').text(window.lang.translate('El mapa és visible a la galeria pública'));
    $('#txtNoVisible').text(window.lang.translate('El mapa només és visible a la teva galeria privada'));
    $('#resetClau').text(window.lang.translate('Reiniciar'));

    $('#cancelPublicar').text(window.lang.translate('Cancel·lar'));
    $('#okPublicar').text(window.lang.translate('Publicar'));

}

function loadMapConfig(mapConfig){
	var dfd = jQuery.Deferred();
	var instamapsLayers = InstamapsLayers({map: map, edit: true});

	if (!jQuery.isEmptyObject( mapConfig )){
		


		jQuery('#businessId').val(mapConfig.businessId);
		//TODO ver los errores de leaflet al cambiar el mapa de fondo
		//cambiar el mapa de fondo a orto y gris
		if (mapConfig.options != null){
			if (mapConfig.options.fons){
				var fons = mapConfig.options.fons;
				map.changeBackgroundType(fons);
				/*
				if (fons == 'topoMap'){
					map.topoMap();
				}else if (fons == 'topoMapGeo') {
					map.topoMapGeo();
				}else if (fons == 'ortoMap') {
					map.ortoMap();
				}else if (fons == 'terrainMap') {
					map.terrainMap();
				}else if (fons == 'topoGrisMap') {
					map.topoGrisMap();
				}else if (fons == 'historicOrtoMap') {
					map.historicOrtoMap();
				}else if (fons == 'historicMap') {
					map.historicMap();
				}else if (fons == 'hibridMap'){
					map.hibridMap();
				}else if (fons == 'historicOrtoMap46'){
					map.historicOrtoMap46();
				}else if (fons == 'alcadaMap'){
					map.alcadaMap();
				}else if (fons == 'naturalMap') {
					map.naturalMap();
				}else if (fons == 'divadminMap') {
					map.divadminMap();
				}else if (fons == 'hibridTerrainMap') {
					map.hibridTerrainMap();
				}else if (fons.indexOf('colorBlankMap')!=-1) {
					map.colorBlankMap(fons);
				}else if (fons == 'colorMap') {
					map.colorMap(mapConfig.options.fonsColor);
				}
				map.setActiveMap(mapConfig.options.fons);
				map.setMapColor(mapConfig.options.fonsColor);
				*/
				//map.gestionaFons();
			}
			if (mapConfig.options.center){
				var opcenter = mapConfig.options.center.split(",");
				map.setView(L.latLng(opcenter[0], opcenter[1]), mapConfig.options.zoom);
			}else if (mapConfig.options.bbox){
				var bbox = mapConfig.options.bbox.split(",");
				var southWest = L.latLng(bbox[1], bbox[0]);
			    var northEast = L.latLng(bbox[3], bbox[2]);
			    var bounds = L.latLngBounds(southWest, northEast);
				map.fitBounds( bounds );
			}
		}
		
		if (mapConfig!==undefined && mapConfig.servidorsWMS!==undefined && mapConfig.servidorsWMS.length>0) {
			if (!InstamapsUtils.Mapa.hiHaServeisWMS(mapConfig.servidorsWMS)){
				map.spin(true);
				instamapsLayers._loadAllLayers(mapConfig, controlCapes).then(function(){
					//self._updateLayerControl();
					controlCapes.forceUpdate(true);
					InstamapsUtils.Mapa.hideSpiner();
					addInfoBloqueigMapa(mapConfig);
					//InstamapsUtils.Mapa.refrescarCapesEtiquetes(controlCapes, mapConfig, map, jQuery);
				});
			}
			else {
				InstamapsUtils.Mapa.loadSpiner(false).then(function(){
					$('#div_loading').modal('show');
					map.spin(true);				
					instamapsLayers._loadAllLayers(mapConfig, controlCapes).then(function(){
							//self._updateLayerControl();
							controlCapes.forceUpdate(true);
							InstamapsUtils.Mapa.hideSpiner();
							addInfoBloqueigMapa(mapConfig);
							//InstamapsUtils.Mapa.refrescarCapesEtiquetes(controlCapes, mapConfig, map, jQuery);
					});
				});
			}
			
			
		}
		
		
		/*map.on('zoomend', function (e) {
			jQuery.each(controlCapes._layers, function(i, obj){
				InstamapsUtils.Mapa.refrescarZoomEtiquetes(obj.layer, null, mapConfig, map, jQuery);
				var propsCapaMare = obj.layer.options;
				jQuery.each(obj._layers, function(i, lay){
					InstamapsUtils.Mapa.refrescarZoomEtiquetes(lay.layer, propsCapaMare, mapConfig, map, jQuery);
				});
			 });
		});*/

		
		
		
			
	}

	dfd.resolve();
	return dfd.promise();
}

function loadOrigenWMS(){
	var dfd = $.Deferred();
	var layer_map = {origen:[],sublayers:[]};
	jQuery.each(mapConfig.servidorsWMS, function(index, value){
		//TODO parsear las options y el group y dejarlo en json.
		//TODO quitar el parse de cada tipo de capa.
		if(value.options && value.capesGroup){
			var options = InstamapsUtils.Dom.cleanOptions(value.options);
			
			var group ;

			if(typeof (value.capesGroup)=="string"){
				try {
					group = JSON.parse(value.capesGroup);
				}
				catch (err) {
					group =value.capesGroup;
				}

			}else{

				group = value.capesGroup;
			}


			options.group = group;
			value.options = JSON.stringify(options);
		}

		if(value.capesOrdre == capesOrdre_sublayer){
			layer_map.sublayers.push(value);
			lsublayers.push(value);
		}else{
			layer_map.origen.push(value);
		}
	});


	jQuery.each(layer_map.origen, function(index, value){
		var jsonOptions = InstamapsUtils.Dom.cleanOptions(value.options);
		
		if(jsonOptions && jsonOptions.group){
			controlCapes._addGroupFromObject(jsonOptions.group);
		}

	});

	dfd.resolve(layer_map);
	return dfd.promise();
}

function loadLayer(value){

	var defer = $.Deferred();

	if (value.epsg == "4326"){
		value.epsg = L.CRS.EPSG4326;
	}else if (value.epsg == "25831"){
		value.epsg = L.CRS.EPSG25831;
	}else if (value.epsg == "23031"){
		value.epsg = L.CRS.EPSG23031;
	}else{
		value.epsg = map.crs;
	}

	//Si la capa es de tipus wms
	if(value.serverType == t_wms){
		loadWmsLayer(value).then(function(){
			defer.resolve();
		});
	//Si la capa es de tipus json
	}else if(value.serverType == t_json){
		loadCapaFromJSON(value).then(function(){
			defer.resolve();
		});
		//Si la capa es de tipus url file
	}else if(value.serverType == t_url_file){
		loadURLfileLayer(value).then(function(){
			defer.resolve();
		});
	//Si la capa es de tipus geojsonVT
	}else if(value.serverType == t_geojsonvt){
		loadGeojsonvtLayer(value);
		defer.resolve();
	//Si la capa es de tipus dades obertes
	}else if(value.serverType == t_dades_obertes){
		loadDadesObertesLayer(value).then(function(){
			defer.resolve();
		});
	//Si la capa es de tipus xarxes socials
	}else if(value.serverType == t_xarxes_socials){
		var options = jQuery.parseJSON( value.options );

		if(options.xarxa_social == 'twitter') loadTwitterLayer(value, options.hashtag);
		else if(options.xarxa_social == 'wikipedia') loadWikipediaLayer(value);
		defer.resolve();
	}else if(value.serverType == t_tematic){
		loadTematicLayer(value).then(function(){
			defer.resolve();
		});
	}else if(value.serverType == t_visualitzacio){
		loadVisualitzacioLayer(value).then(function(){
			defer.resolve();
		});
	//Si la capa es de tipus vis_wms
	}else if(value.serverType == t_vis_wms || value.serverType == t_vis_wms_noedit){
		loadVisualitzacioWmsLayer(value);
		defer.resolve();
	}
	else if(value.serverType == tem_heatmap_wms || value.serverType == tem_cluster_wms){
		loadVisualitzacioWmsLayerSenseUtfGrid(value);
		defer.resolve();
	}
	return defer.promise();
}


function createNewMap(){
	
	var tipusApp = 'vis';

	if(isGeolocalUser() || (typeof url('?tipus') == "string" && url('?tipus')=="geolocal") ){
		tipusApp = 'geolo'; //para visores geolocal
	}

	if(isSostenibilitatUser(false)|| (typeof url('?tipus') == "string" && url('?tipus')=="sostenibilitat") ){
		tipusApp = 'vis'; //para visores sostenibilitat
	}	

	if(isEuroregioUser() || (typeof url('?tipus') == "string" && url('?tipus')=="euroregio") ){
		tipusApp = 'eureg';
	}
	
	var data = {
		nom: InstamapsUtils.Getters.getTimeStamp(),
		uid: Cookies.get('uid'),
		visibilitat: visibilitat_privat,
		tipusApp: tipusApp,
	};

	createMap(data).then(function(results){
		
		if (results.status == "ERROR"){
			//TODO Mensaje de error
			InstamapsUtils.Cookie.gestioCookie("createMapError", paramUrl, Cookies, url);
		}else{
			try{
				mapConfig = results.results;
				mapConfig.options = jQuery.parseJSON( mapConfig.options );
				jQuery('#businessId').val(mapConfig.businessId);
				mapConfig.newMap = false;
				var urlFile="";
				var tipusFile="";
				if (window.localStorage){
					if (window.localStorage.getItem("url")) urlFile=window.localStorage.getItem("url");
				}
				if (window.localStorage){
					if (window.localStorage.getItem("format")) tipusFile=window.localStorage.getItem("format");
				}
				//Si hi ha parametre enllac servei wms, etc
				var param = "";
				if(typeof url('?urlwms') == "string"){
					param = "&urlwms="+url('?urlwms')+"&layername="+url('?layername');
				}
				if (urlFile!=""){
					param += "&url="+urlFile;
				}
				if (tipusFile!=""){
					param += "&format="+tipusFile;
				}
				if (tipusApp=="geolo") window.location = paramUrl.mapaPage+"?businessid="+mapConfig.businessId+param+"&tipus=geolocal";
				else window.location = paramUrl.mapaPage+"?businessid="+mapConfig.businessId+param;

			}catch(err){
				InstamapsUtils.Cookie.gestioCookie("createMap", paramUrl, Cookies, url);
			}
		}
	});
}

/**
 * Obtener los businessId de las capas para crear los json
 */
function getBusinessIdOrigenLayers(){
    var lBusinessId = "";
    jQuery.each(controlCapes._layers, function(i, item){
          lBusinessId += item.layer.options.businessId +",";
          jQuery.each(item._layers, function(j, subitem){
        	  if( subitem.layer.options.tipusRang == tem_simple || subitem.layer.options.tipusRang == tem_clasic){
            	  lBusinessId += subitem.layer.options.businessId +",";
              }
          });
    });
    lBusinessId = lBusinessId.substring(0, lBusinessId.length - 1);
    return lBusinessId;

}

function getTrafficLightKeys()
{

	var lBusinessId = "";
	jQuery.each(controlCapes._layers, function(i, item){
		lBusinessId += ",";
		jQuery.each(item._layers, function(j, subitem){
			if( subitem.layer.options.tipusRang == tem_simple || subitem.layer.options.tipusRang == tem_clasic)
			{

				if(subitem.layer.options.hasOwnProperty("trafficLightValue"))
					lBusinessId += subitem.layer.options.trafficLightValue +",";
				else
					lBusinessId += ",";

			}
		});
    });
    lBusinessId = lBusinessId.substring(0, lBusinessId.length - 1);
    return lBusinessId;

}

function loadControls(configuracio){
	jQuery.each(configuracio.funcionalitats, function(i, funcionalitat){
		eval(funcionalitat);
	});
	//funcionalitats a carregar nomes si esta loginat
	if (Cookies.get('uid')){
		jQuery.each(configuracio.funcionalitatsLoginat, function(i, funcionalitatLoginat){
			eval(funcionalitatLoginat);
		});
	}
}

function loadConfiguracio(configuracio){
	var dfd = new jQuery.Deferred();
	if(configuracio){
		configuracio = $.parseJSON(mapConfig.configuracio);
		dfd.resolve(configuracio);
	}else{
		jQuery.get(paramUrl.configFile, function(data) {
			   configuracio = $.parseJSON(data);
			   dfd.resolve(configuracio);
		});
	}
	return dfd.promise();
}

function addLeaveModal(){
	addHtmlModalLeave();

	if (InstamapsUtils.Validator.isRandomUser(Cookies.get('uid'))){
		jQuery('#hl_sessio1').attr('href', paramUrl.loginPage+"?from=mapa");

		jQuery('.navbar-form .bt-sessio').on('click',function(){
			jQuery(window).off('beforeunload');
			jQuery(window).off('unload');
			window.location = paramUrl.loginPage+"?from=mapa";
		});

		jQuery('#dialgo_leave').modal('show');
		jQuery('#dialgo_leave .bt-sessio').on('click',function(){
			jQuery(window).off('beforeunload');
			jQuery(window).off('unload');
			window.location = paramUrl.loginPage+"?from=mapa";
		});

		jQuery('#dialgo_leave .bt_orange').on('click',function(){
			jQuery(window).off('beforeunload');
			jQuery(window).off('unload');
			window.location = paramUrl.registrePage+"?from=mapa";
		});

		jQuery('#dialgo_leave').on('hide.bs.modal', function (e) {

		});

		jQuery(window).on('unload',function(event){
			//$.publish('analyticsEvent',{event:['mapa', tipus_user+'sortir', 'label sortir', 1]});
			deleteRandomUser({uid: Cookies.get('uid')});
			Cookies.remove('uid');
		});
	}else{
		jQuery('#dialgo_leave .btn-primary').on('click',function(){
			leaveMapa();
		});
	}

	$('.leaflet-remove').click(function() {
		alert( "Handler for .click() called." );
	});

	//boton de comentaris
	jQuery('#feedback_btn').on('click',function(e){
		window.open(paramUrl.comentarisPage);
	});
	//Missatge error de carrega de dades
	jQuery("#div_carrega_dades_message").hide();
	jQuery('#dialog_carrega_dades').on('hidden.bs.modal', function (e) {
		jQuery("#div_carrega_dades_message").hide();
	});

}

function nobackbutton(){
	window.location.hash="no-back-button";
    window.location.hash="Again-No-back-button" //chrome
    window.onhashchange=function(){window.location.hash="no-back-button";}
}

function addHtmlModalBloqueigMapa(){
	$.get("/static/geocatweb/templates/modalBloqueigMapa.html",function(data){
		$('#mapa_modals').append(data);
		//Desbloquejar el mapa
		$('#dialog_bloqueig_mapa .btn-danger').on('click', function(event){
			window.clearTimeout(timeoutBloqueig);
			$('#dialog_bloqueig_mapa').modal('hide');
			InstamapsUtils.Mapa.treureBloqueigMapa(jQuery, url, Cookies, lockController, runningActions, desbloquejarMapa);
		});
		//Continuar treballant amb el mapa
		$('#dialog_bloqueig_mapa .btn-default').on('click', function(event){
			window.clearTimeout(timeoutBloqueig);
			$('#dialog_bloqueig_mapa').modal('hide');
			//Reinicialitzar el temps del controlador!
			lockController.start();
		});
	});

	if(typeof url('?url') == "string"){
		var urlFile = url('?url');
		var tipusFile="geojson";
		if(typeof url('?format') == "string"){
			tipusFile=url('?format');
		}
		if (tipusFile.toLowerCase().indexOf("geojson")>-1) tipusFile=".geojson";
		if (tipusFile.toLowerCase().indexOf("kml")>-1) tipusFile=".kml";
		if (tipusFile.toLowerCase().indexOf("kmz")>-1) tipusFile=".kmz";
		if (tipusFile.toLowerCase().indexOf("gpx")>-1) tipusFile=".gpx";
		deleteLocalStorage();
		new InstamapsUrlFile().createURLfileLayer(urlFile, tipusFile, "EPSG:4326", true,"Capa urlFile","","","","","","","");
	}
}

function deleteLocalStorage(){
	try{
		if(window.localStorage){
			window.localStorage.removeItem("url");
			window.localStorage.removeItem("format");
		}
	}catch(e){}
}

function addHtmlModalInfoBloqueigMapa(){
	$.get("/static/geocatweb/templates/modalInfoBloqueigMapa.html",function(data){
		$('#mapa_modals').append(data);
		$('#dialog_info_bloqueig_mapa .btn-default').on('click', function(event){
			$('#dialog_info_bloqueig_mapa').modal('hide');
		});

	});
}

function addInfoBloqueigMapa(mapConfig){
	addHtmlModalInfoBloqueigMapa();
	//Si és un mapa col·laboratiu mostrem la finestra de informació de bloqueig
	if (typeof mapConfig.bloquejat == "string" && mapConfig.bloquejat.indexOf("bloquejat")>-1  && mapConfig.bloquejat.indexOf("null")==-1) {
		setTimeout(function() {
			$('#dialog_info_bloqueig_mapa').modal('show');
		}, 1000);
	}
}

function changeLogoByTipusEntitat(tipusEntitatId){
	if (12 === parseInt(tipusEntitatId)){
		$('header .logo').attr("src","/static/img/logo_EPM.jpg").addClass('logo_euroregio');
	}
}

function changeFonsByTipusEntitat(tipusEntitatId){
	if (12 === parseInt(tipusEntitatId)){
		map.changeBackgroundType("topoEuroRegio");
	}
}

function changeVistaInicialByTipusEntitat(tipusEntitatId){
	if (12 === parseInt(tipusEntitatId)){
		var vistaInit = VISTES_INICIALS[12];
		map.setView(L.latLng(vistaInit.lat, vistaInit.lng), vistaInit.zoom);
	}
}

function changeFonsListByTipusEntitat(tipusEntitatId){
	if (12 === parseInt(tipusEntitatId)){
		$('#euroRegioFons').removeClass('hidden').show();
	}
}

function addHtmlModalAddLayer(){
	$.get("/static/geocatweb/templates/modalAddToLayer.html",function(data){
		$('#mapa_modals').append(data);
			
			$('#dialog_add_layer .close').on('click',function(){
				event.preventDefault();
				event.stopImmediatePropagation();						
				jQuery('#dialog_add_layer').hide();
				$('#dialog_add_layer .close').off('click');
			});	
			
		//	jQuery('.modal').modal('hide');    
	});
}

/*TODO estas funciones estaban pensadas para prevenir al usaurio al abandonar
la pagína sin publicar el mapa. La idea era que al entrar en un mapa nuevo
se creara el mapa en la BD y que el si el usuario abandona la página sin publicar se
mostrara el mensaje de advertencia y se borrara el mapa.
*/
/*
function avisDesarMapa(){
	//console.debug(mapConfig.newMap);
	if (mapConfig.newMap){
		jQuery(window).on('beforeunload',function(event){
			//$('#dialgo_leave').modal('show');
			//event.stopPropagation();
			//event.preventDefault();
			//console.debug("antes de ir e");
			//return "Mensaje de aviso que no se muestra en Firefox";
		});
	}else{
		jQuery(window).off('beforeunload',function(){
			return true;
		});
	}
}

function leaveMapa(){
	console.debug("borrar el mapa e ir a la galeria");
}
*/
